import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import dayjs from 'dayjs';
import { getStatusLabel } from '../../../util/paymentUtils';
import { getPaymentStatusIcon, getRefundStatusIcon } from './paymentStatusIcons';

function PaymentDetails({ payment, loading, getPaymentMethod }) {
  if (loading) {
    return (
      <Box display='flex' justifyContent='center' p={2}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!payment) {
    return (
      <Typography variant='body2' color='text.secondary'>
        Keine Zahlungsdaten verfügbar
      </Typography>
    );
  }

  return (
    <Paper sx={{ p: 2, bgcolor: 'rgba(0, 0, 0, 0.04)' }}>
      <Box display='flex' justifyContent='space-between' alignItems='center' sx={{ mb: 2 }}>
        <Typography variant='body2'>
          <strong>
            Zahlung vom{' '}
            {payment.startedAt ? dayjs(payment.startedAt).format('DD.MM.YYYY HH:mm') : '-'}
          </strong>
        </Typography>
        {getPaymentStatusIcon(payment.status)}
      </Box>
      <Box sx={{ pl: 2 }}>
        <Typography variant='body2'>
          <strong>Status:</strong> {getStatusLabel(payment.status)}
        </Typography>
        <Typography variant='body2'>
          <strong>Betrag:</strong> {payment.amount?.toFixed(2).replace('.', ',')} €
        </Typography>
        {getPaymentMethod && (
          <Typography variant='body2'>
            <strong>Methode:</strong> {getPaymentMethod(payment)}
          </Typography>
        )}
        {payment.authorizedAt && (
          <Typography variant='body2'>
            <strong>Autorisiert am:</strong>{' '}
            {dayjs(payment.authorizedAt).format('DD.MM.YYYY HH:mm')}
          </Typography>
        )}
        {payment.attemptCount > 1 && (
          <Typography variant='body2'>
            <strong>Anzahl Versuche:</strong> {payment.attemptCount}
          </Typography>
        )}
        {payment.buyerMail && (
          <Typography variant='body2'>
            <strong>Käufer E-Mail:</strong> {payment.buyerMail}
          </Typography>
        )}
      </Box>

      {payment.refunds?.length > 0 && (
        <Box sx={{ pl: 2, borderLeft: '2px solid #e0e0e0', mt: 2 }}>
          <Typography variant='subtitle2' gutterBottom>
            Erstattungen
          </Typography>
          {payment.refunds.map(refund => (
            <Paper
              key={refund.refundPspReference || refund._id}
              sx={{ p: 2, mb: 1, bgcolor: 'rgba(0, 0, 0, 0.04)' }}
            >
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Typography variant='body2'>
                  <strong>Datum:</strong> {dayjs(refund.date).format('DD.MM.YYYY HH:mm')}
                </Typography>
                {getRefundStatusIcon(refund.status)}
              </Box>
              <Typography variant='body2'>
                <strong>Status:</strong> {getStatusLabel(refund.status)}
              </Typography>
              <Typography variant='body2'>
                <strong>Betrag:</strong> -{refund.amount?.toFixed(2).replace('.', ',')} €
              </Typography>
              {refund.refundError && (
                <Typography variant='body2' color='error'>
                  <strong>Fehler:</strong> {refund.refundError}
                </Typography>
              )}
            </Paper>
          ))}
        </Box>
      )}
    </Paper>
  );
}

export default PaymentDetails;
